import {
  PIECHART_DATA_FETCHED,
  LINECHART_DATA_FETCHED,
  CARD_DATA_FETCHED,
} from "../types";

const initialState = {
  pieChartData: [] as any,
  lineChartData: [] as any,
  cardData: [] as any,
};
const dashboard = (state = initialState, action: any) => {
  switch (action.type) {
    case PIECHART_DATA_FETCHED:
      return {
        ...state,
        pieChartData: action.pieChartData,
      };

    case LINECHART_DATA_FETCHED:
      return {
        ...state,
        lineChartData: action.lineChartData,
      };
    case CARD_DATA_FETCHED:
      return {
        ...state,
        cardData: action.cardData,
      };

    default:
      return state;
  }
};

export default dashboard;



